import { fetchPartnerListFailure, fetchPartnerListSuccess } from "./reducer"
import { PARTNER_ALLLISTING_API } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const getAllPartnerListing = (setLoading, PartnerId, initialValues, setEditData, setDialCode, setDialCodeBP) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await determineBaseUrlAndPerformApiCall(`${PARTNER_ALLLISTING_API}/${PartnerId}`, 'GET')

        if (!response.error) {

            setEditData(response)

            // Populate the initialValues object that was passed from the component
            initialValues.businessName = response.businessName || ''
            initialValues.type = response.type ? { "value": response.type, "label": response.type } : ''
            initialValues.email = response.emailAddress || ''

            // Set dial codes
            const businessPhone = response?.dialCode && response?.mobile
                ? `${response.dialCode}${response.mobile}`
                : ''
            setDialCodeBP(businessPhone)

            initialValues.mobile = response.mobile || ''
            initialValues.Address = response.addressLine1 || ''
            initialValues.state = response.state ? { "value": response.state, "label": response.state } : ''
            initialValues.country =response.country ? { "value": response?.country, "label": response?.country }:''
            initialValues.city = response.city ? { "value": response.city, "label": response.city } : ''
            initialValues.websiteLink = response.websiteHref || ''
            initialValues.zipCode = response.zipcode || ''
            initialValues.addressLine2 = response.addressLine2 || ''
            initialValues.attributeList = response.characteristic || []
            initialValues.isSSOUser = response.isSSOUser || false

            // Primary contact information
            if (response.primaryContact) {
                initialValues.firstName = response.primaryContact.firstName || ''
                initialValues.lastName = response.primaryContact.lastName || ''
                initialValues.email1 = response.primaryContact.emailAddress || ''
                initialValues.mobile1 = response.primaryContact.mobile || ''
                initialValues.id = response.primaryContact.id || ''

                // Set primary contact dial code
                const primaryPhone = response.primaryContact?.dialCode && response.primaryContact?.mobile
                    ? `${response.primaryContact.dialCode}${response.primaryContact.mobile}`
                    : ''
                setDialCode(primaryPhone)
            }

            dispatch(fetchPartnerListSuccess(response));

        } else {
            console.error("API Error:", response.error);
            dispatch(fetchPartnerListFailure(response.error.message));
        }

        setLoading(false)

    } catch (error) {
        console.error("Thunk Error:", error);
        setLoading(false);
        dispatch(fetchPartnerListFailure(error.message || "An error occurred"));
    }
};